<template>
  <v-bottom-sheet
    v-model="dialog"
    persistent
    inset
  >
    <v-card
      class="pa-4 bg-grey-darken-4"
      elevation="0"
    >
      <v-card-title class="text-h6">We use cookies</v-card-title>
      <v-card-text>
        This website uses cookies to enhance your browsing experience. By clicking "Accept", you
        consent to our use of cookies. Learn more in our
        <a
          href="/privacy-policy"
          target="_blank"
          class="text-white"
        >
          Privacy Policy.
        </a>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          data-test="decline"
          variant="text"
          @click="decline"
        >
          Decline
        </v-btn>
        <v-btn
          data-test="accept"
          color="primary"
          variant="flat"
          @click="accept"
        >
          Accept
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>

<script setup lang="ts">
  import { ref, onMounted } from 'vue';
  import { rootComputed } from '@/store';

  const dialog = ref(false);
  const { cookieConsent } = rootComputed.writable;

  onMounted(() => {
    if (!cookieConsent.get()) {
      dialog.value = true;
    }
  });

  function accept() {
    cookieConsent.set('accepted');
    dialog.value = false;
  }

  function decline() {
    cookieConsent.set('declined');
    dialog.value = false;
  }
</script>

<style lang="scss" scoped></style>
